import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Conversations from '../../components/messenger/Conversations'
import MessagePanel from '../../components/messenger/MessagePanel' 
import { PageContainerMain } from 'pages/pages.styled'
import Sidebar from 'components/Sidebar'

function SelectedConversation() {
  const navigate = useNavigate()
  const { user } = useSelector( state => state.auth)

  useEffect(() => {
    if(!user){ navigate('/login') }

 
  }, [navigate, user])



  return (
    <PageContainerMain>
        <Sidebar />
        <Conversations /> 
        <MessagePanel />
    </PageContainerMain>
  )
}

export default SelectedConversation
 

//  learn about useMatch on react-router-dom to be able to highlight 
//background of conversationlistItmes when url param matches the conversation ID